import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "apple-price-card__text" }
const _hoisted_2 = { class: "apple-price-card__title" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "apple-price-card__price wg-no-translate" }
const _hoisted_5 = { class: "apple-price-card__price-subtitle" }
const _hoisted_6 = { class: "wg-no-translate" }
const _hoisted_7 = { class: "apple-price-card__logos" }

import { computed } from 'vue'

import type { PlanView } from '@/models/billing'

import Divider from '@/components/ui/Divider.vue'
import AppButton from '@/app/components/button/AppButton.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'BillingApplePriceCard16218',
  props: {
    plan: {},
    isExternal: { type: Boolean }
  },
  emits: ['subscribe'],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const title = computed(() => {
  return props.isExternal ? 'External Payment' : 'Apple Purchase'
})

const subtitle = computed(() => {
  return props.isExternal
    ? 'External payment can be through <strong>Stripe</strong>, <strong>Apple Pay</strong>, or <strong>Google Pay</strong>.'
    : 'Payment via in-app purchase (App Store).'
})

const logos = computed(() => {
  return props.isExternal ? ['stripe', 'google', 'apple'] : ['apple']
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["apple-price-card", { 'apple-price-card--external': __props.isExternal }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h3", _hoisted_2, _toDisplayString(title.value), 1),
      _createElementVNode("p", {
        class: "apple-price-card__subtitle",
        innerHTML: subtitle.value
      }, null, 8, _hoisted_3),
      _createVNode(Divider, { class: "apple-price-card__divider" }),
      _createElementVNode("p", _hoisted_4, _toDisplayString(__props.plan.price.withPeriod.perMonth), 1),
      _createElementVNode("p", _hoisted_5, [
        (__props.plan.id === 'plan_monthly')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode("Billed monthly")
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _cache[1] || (_cache[1] = _createTextVNode(" Billed annually at ", -1)),
              _createElementVNode("span", _hoisted_6, _toDisplayString(__props.plan.price.perPeriod), 1)
            ], 64))
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(logos.value, (logo) => {
        return (_openBlock(), _createElementBlock("div", {
          key: logo,
          class: _normalizeClass(["apple-price-card__logo", `apple-price-card__logo--${logo}`])
        }, null, 2))
      }), 128))
    ]),
    _createVNode(AppButton, {
      class: "apple-price-card__button",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('subscribe')))
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(title.value), 1)
      ]),
      _: 1
    })
  ], 2))
}
}

})